import { inventarioApi, isOfflineError } from './inventarioApi';

const QUEUE_KEY = 'inventario_offline_queue';

const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY)) || []; }
  catch { return []; }
};

const saveQueue = (queue) => localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));

export const offlineQueue = {
  enqueue: ({ method, entidad, body, id }) => {
    const queue = getQueue();
    queue.push({ method, entidad, body, id, timestamp: Date.now() });
    saveQueue(queue);
  },

  flush: async () => {
    const queue = getQueue();
    if (queue.length === 0) return true;

    const remaining = [];
    for (let i = 0; i < queue.length; i++) {
      const req = queue[i];
      try {
        if (req.entidad === 'limpiezas') {
          if (req.method === 'DELETE') {
            await inventarioApi.anularLimpieza(req.id);
          } else if (req.method === 'POST' && req.body?._op === 'convertir_desde_gasto') {
            const { _op, gastoId, ...payload } = req.body;
            await inventarioApi.convertirGastoALimpieza(gastoId, payload);
          } else if (req.method === 'POST') {
            await inventarioApi.crearLimpieza(req.body);
          } else {
            throw new Error(`Método no soportado para limpiezas: ${req.method}`);
          }
        } else {
          switch (req.method) {
            case 'POST': await inventarioApi.create(req.entidad, req.body); break;
            case 'PUT': await inventarioApi.replace(req.entidad, req.body); break;
            case 'PATCH': await inventarioApi.patch(req.entidad, req.body); break;
            case 'DELETE': await inventarioApi.remove(req.entidad, req.id); break;
            default: break;
          }
        }
      } catch (e) {
        // Never discard failed requests: keep failed + following to preserve order.
        console.error('[inventario offlineQueue] Error al sincronizar item', req, e?.response?.data || e.message);
        remaining.push(...queue.slice(i));
        if (isOfflineError(e)) {
          break;
        }
        break;
      }
    }
    saveQueue(remaining);
    return remaining.length === 0;
  },

  hasPending: () => getQueue().length > 0,
};

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => offlineQueue.flush());
}
